import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Page-level SEO component.
 * Usage: <SEO title="..." description="..." image="..." canonical="..." />
 * Falls back to sane defaults for the Luna·Home storefront.
 */
const DEFAULTS = {
  title: "Luna. Creative Home — A home where creativity grows",
  description: "A curated edit of Scandinavian-leaning essentials. Thoughtfully chosen, carefully stocked. Free delivery over $75.",
  image: "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=1200",
  siteName: "Luna. Creative Home",
};

export default function SEO({
  title,
  description,
  image,
  canonical,
  type = "website",
  noindex = false,
  keywords,
}) {
  const fullTitle = title ? `${title} — Luna. Creative Home` : DEFAULTS.title;
  const desc = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const href = canonical || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {img && <meta property="og:image" content={img} />}
      {href && <meta property="og:url" content={href} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
    </Helmet>
  );
}
